import React, { useCallback } from 'react';
import { Stack, RadioButton, Overlay } from '@moda/om';
import { PaymentSource } from '../../../../constants';
import { LoadingBalls } from '../../../LoadingBalls';
import { OrderSummary } from '../../../../hooks/useOrderSummary';
import { useUpdateOrder } from '../../../../hooks/useUpdateOrder';
import { useAffirmSecondPayment } from '../../../../hooks/useAffirmSecondPayment';

import './OrderDetailsPaymentMethodOptions.scss';

interface Props {
  orderSummary: OrderSummary;
}

export const OrderDetailsPaymentMethodOptions: React.FC<Props> = ({ orderSummary }) => {
  const { setOrderPayRemainingBalance, loading } = useUpdateOrder(orderSummary.id);
  const { isAffirmAvailable } = useAffirmSecondPayment();

  const { isPaymentChangeable, affirmSecondChargeEnabled } = orderSummary.attributes;

  const handleChange = useCallback(
    (newPaymentSource: PaymentSource) => {
      setOrderPayRemainingBalance(newPaymentSource.toLowerCase());
    },
    [setOrderPayRemainingBalance]
  );

  if (!isAffirmAvailable || !isPaymentChangeable) return null;

  return (
    <Stack
      alignItems="center"
      direction="horizontal"
      justifyContent="space-between"
      space={4}
      className="OrderDetailsPaymentMethodOptions"
    >
      <Stack direction="horizontal" space={5}>
        <RadioButton
          checked={!affirmSecondChargeEnabled}
          onChange={() => handleChange(PaymentSource.Adyen)}
        >
          Debit/Credit Card
        </RadioButton>

        <RadioButton
          checked={Boolean(affirmSecondChargeEnabled)}
          onChange={() => handleChange(PaymentSource.Affirm)}
        >
          <img className="OrderDetailsPaymentMethodOptions__logo" alt="Affirm" src="/affirm.png" />
        </RadioButton>
      </Stack>

      <Overlay show={loading}>
        <LoadingBalls />
      </Overlay>
    </Stack>
  );
};
